export default __webpack_public_path__ + "static/media/imgLightEn6.9c14a754.png";